
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="searchMember($event)"
                    placeholder="સભ્યો શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <a class="ti ti-refresh cursorClass" (click)="this.getNriList()"></a>
        </div>
    </div>

    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
        <mat-tab label="NRI સભ્યોની યાદી">
            <div class="main-members family-tabs">
                <a *ngFor="let member of nriListData" class="member-list-item">                    
                    <ng-container [ngSwitch]="member.image !== ''">
                        <img *ngSwitchCase="true" [src]="baseUrl + member.image" />
                        <img *ngSwitchCase="false" src="../../../assets/img/user_.jpg" />
                    </ng-container>
                    <div>
                        <h5>{{ member.name }}</h5>
                        <p>{{ member.contact_no}}</p>
                        <p>{{member.business}}
                            <span *ngIf="member.business && member.city_name"> | </span>
                            {{member.city_name}}
                        </p>
                    </div>
                </a>
            </div>
        </mat-tab>
    </mat-tab-group>
</main>